module.exports = __webpack_public_path__ + "img/main_15.5122478a.jpg";